import { NavItem } from '../../types'
import { routes } from '../../routes'

const navItems: NavItem[] = [
  {
    item: 'Obituaries',
    location: routes.obituaries,
    activeMatch: new RegExp(`${routes.obituaries}/*`, 'i'),
  },
  {
    item: 'About Us',
    location: routes.about,
    activeMatch: new RegExp(routes.about, 'i'),
  },
  {
    item: 'The Kalas Difference',
    location: routes.howWeCelebrate,
    activeMatch: new RegExp(routes.howWeCelebrate, 'i'),
  },
  {
    item: 'Veteran Services',
    location: routes.veteranServices,
    activeMatch: new RegExp(routes.veteranServices, 'i'),
  },
  {
    item: 'Planning Ahead',
    location: routes.planningAhead,
    activeMatch: new RegExp(routes.planningAhead, 'i'),
  },
  {
    item: 'Contact',
    location: routes.contact,
    activeMatch: new RegExp(routes.contact, 'i'),
  },
]

export default navItems
